import { render, staticRenderFns } from "./setDeliveryDialog.vue?vue&type=template&id=5d47a6d4&scoped=true&"
import script from "./setDeliveryDialog.vue?vue&type=script&lang=js&"
export * from "./setDeliveryDialog.vue?vue&type=script&lang=js&"
import style0 from "./setDeliveryDialog.vue?vue&type=style&index=0&id=5d47a6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d47a6d4",
  null
  
)

export default component.exports